import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  icon: React.ReactNode;
  severity?: 'info' | 'warning';
  sx?: SxProps<Theme>;
  text: React.ReactNode;
}

export default function ReportNote({ icon, severity = 'info', sx, text }: Props) {
  const isWarning = severity === 'warning';
  const content =
    typeof text === 'string' ? (
      <Typography variant="body2">{text}</Typography>
    ) : (
      <Box sx={{ typography: 'body2' }}>{text}</Box>
    );

  return (
    <Stack
      direction="row"
      spacing={1.25}
      sx={[
        {
          alignItems: 'flex-start',
          bgcolor: isWarning ? 'warning.50' : 'grey.50',
          borderBottom: 1,
          borderColor: isWarning ? 'warning.light' : 'divider',
          color: isWarning ? 'warning.dark' : 'text.secondary',
          p: 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ color: isWarning ? 'warning.main' : 'info.main', display: 'flex', mt: 0.125 }}>{icon}</Box>
      {content}
    </Stack>
  );
}
